import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTriangleExclamation, faHandPointer } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from "react-router-dom";
import clientInformation from '../login/ClientInfo';
import { PendingPayouts } from "../../services/PayoutService";

export const CustomerInfoHeader = () => {
    const clientInfo = clientInformation();
    const navigate = useNavigate();
    const [arrayPendigPayouts, setPendingPayouts] = useState([]);
    useEffect(() => {
        var PayoutData = {
            "Token": localStorage.getItem('Token')
        };
        PendingPayouts(PayoutData).then(async function (response) {
            setPendingPayouts(response.Authentication);
        })

    }, [])

    return (
        <div className="componentload">
            <div className="row">
                <div className="col-12 mt-3">
                    &nbsp;
                </div>
             </div>
            <div className="row">
                <div className="col-md-8 col-sm-12">
                    <div className="row px-md-4 py-md-3 mx-3 mb-3 alert border-orange alert alert-warning alert-white header-payout">
                        <div className="col-md-4 pr-5 text-center">
                            <div onClick={() => navigate('/payoutHistory/')} className="btn btn-squared-default-plain btn-white payout-header-text" >
                                <FontAwesomeIcon icon={faHandPointer} size="4x" beat  />
                                <br />
                                Track your
                                <br />
                                Redemption
                                
                            </div>
                        </div>
                        <div className=" col-md-8 pr-5 d-none d-md-block center">
                                <b>Once your redemption request has been registered, you can easily track the status of it, by clicking in the hand </b>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12">
                    <div className="row  px-md-4 py-md-3 mx-3 mb-3 alert border-orange alert alert-warning alert-white header-payout">
                        <div className="col-12">
                            <div className="row mb-2">
                                <div className="col-6 text-left">
                                Account ID:
                                </div>
                                <div className="col-6 text-right">
                                    {clientInfo.CustomerPIN}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6 text-left">
                                    Balance:
                                </div>
                                <div className="col-6 text-right">
                                    {clientInfo.WithdrawalBalance}
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-6 text-left">
                                    Payouts:
                                </div>
                                <div className="col-6 text-right">
                                    {arrayPendigPayouts?.PendingPayouts} Pending
                                </div>
                            </div>
                        </div>
                            
                    </div>
                </div>
            </div>
            {/*<div className="row ">*/}
            {/*    <div className="col-12">*/}
            {/*        <div className="alert alert-warning alert-white squared justify-content-between border-width-4 px-4 py-3 mx-3 mb-3 border-orange">*/}
            {/*            <div className="icon"><FontAwesomeIcon icon={faTriangleExclamation} size="2x" /></div>*/}
            {/*            <div className="mx-5"><strong>Alert!</strong> Don't forget to save your data.</div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
           
        </div> 
        )
}